module.exports = __webpack_public_path__ + "media/src/images/dandori/step6-de5909638dce8c49c648a3adf56122aa.png";